import React from "react";
import { Outlet } from "react-router-dom";

const ContactRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ContactRoot;
